const GET_AUDIT_DATES_LIST = 'GET_AUDIT_DATES_LIST'
const SET_AUDIT_DATES_LIST = 'SET_AUDIT_DATES_LIST'
const CREATE_AUDIT = 'CREATE_AUDIT'
const CREATE_AUDIT_SUCCESS = 'CREATE_AUDIT_SUCCESS'
const UPDATE_AUDIT = 'UPDATE_AUDIT'
const UPDATE_AUDIT_SUCCESS = 'UPDATE_AUDIT_SUCCESS'
const DELETE_AUDIT = 'DELETE_AUDIT'
const DELETE_AUDIT_SUCCESS = 'DELETE_AUDIT_SUCCESS'

export {
    GET_AUDIT_DATES_LIST,
    SET_AUDIT_DATES_LIST,
    CREATE_AUDIT,
    CREATE_AUDIT_SUCCESS,
    UPDATE_AUDIT,
    UPDATE_AUDIT_SUCCESS,
    DELETE_AUDIT,
    DELETE_AUDIT_SUCCESS
}